module.exports = __webpack_public_path__ + "media/images/swimming-hero-628a9cafb1290a3946985fcf9795ac37.jpg";